// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"UploadComponentStyle_inputWrapper__CsSem","fileInput":"UploadComponentStyle_fileInput__1caQZ","buttom":"UploadComponentStyle_buttom__13bID"};